<template>
  <section class="loading-page">
    <bg-div :bgArr="loadingBg" :ow="750" :bgSize="'cover'" :bgPos="'center'">
      <mid-div
        style="z-index:1"
        :src="barOuter.src"
        :pos="barOuter.pos"
        :size="barOuter.size"
        :isImg="true"
      />
      <mid-div
        style="z-index:1"
        :src="barInner.src"
        :pos="barInner.pos"
        :size="barInner.size"
        :isImg="true"
      />
      <preload ref='preload' @load-start="$bus.emit('home-show')" @progress="progress = $event;" @finish="handleFinish" :imgs="imgs" />
    </bg-div>
  </section>
</template>
<script>
import ImagePreload from '../../components/preload/ImagePreload';
import preloadList from '../../constants/preloadList';
import MidDiv from '../../components/wrapper/MidDiv';
import BgDiv from '../../components/wrapper/BackgroundWrapper';
import { loadingBg, barOuter, barInner } from '../../constants/aboutStyle';

export default {
  components: {
    preload: ImagePreload,
    'bg-div': BgDiv,
    'mid-div': MidDiv
  },
  computed: {
    loadingBg() {
      return loadingBg;
    },
    barOuter() {
      return barOuter;
    },
  },
  watch:{
    progress(val){
      if(val){
        this.barInner.size.width = 552*(val.loaded/val.total);
      }
    }
  },
  data() {
    // 预载资源
    let imgs = [];
    imgs = imgs.concat(preloadList);
    return {
      imgs: imgs,
      progress: 0,
      barInner:barInner
    };
  },
  mounted(){
    setTimeout(()=>{
      this.$refs['preload'].load();
    },10)
  },
  methods:{
    test(val){
      console.log('progress:',val);
    },
    handleFinish(){
      setTimeout(()=>{
        this.$emit('finish')
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.loading-page {
  @include abs-full-page;
  @include flex-both-middle;
  background: black;
  z-index: 1000;
}
</style>
